import React, { useState, useEffect } from "react";
import { Modal, Form, Input, message, Checkbox } from "antd";
import { CustomListService } from "../../Services/CustomListService";
import { TextService } from "../../Services/TextService";
import { WebApiCustomListsDtoCustomListDto } from "../../Repository/eventbookyapi";
import { MembersEditRights } from "../../Types/MembersEditRights";

interface EditCustomListModalProps {
    open: boolean;
    onClose: () => void;
    onSuccess: () => void;
    customList: WebApiCustomListsDtoCustomListDto;
    hasOnlyReadRights?: boolean;
}

const EditCustomListModal: React.FC<EditCustomListModalProps> = ({
    open,
    onClose,
    onSuccess,
    customList,
    hasOnlyReadRights = false,
}) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const GetText = TextService.GetText;

    useEffect(() => {
        if (open && customList) {
            form.setFieldsValue({
                name: customList.name,
                allowMembersEdit: customList.membersEditRights === MembersEditRights.OwnItems,
            });
        }
    }, [open, customList, form]);

    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();
            setLoading(true);

            await CustomListService.UpdateCustomList(customList.id!, {
                name: values.name,
                membersEditRights: values.allowMembersEdit ? MembersEditRights.OwnItems : MembersEditRights.None,
            });

            message.success(GetText("Common_Saved"));
            form.resetFields();
            onSuccess();
            onClose();
        } catch (error) {
            message.error(GetText("CustomList_FailedToUpdateName"));
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = () => {
        form.resetFields();
        onClose();
    };

    return (
        <Modal
            title={GetText("CustomList_EditName")}
            open={open}
            onOk={handleSubmit}
            onCancel={handleCancel}
            okText={GetText("Common_Save")}
            cancelText={GetText("Common_Cancel")}
            confirmLoading={loading}
            okButtonProps={{ disabled: hasOnlyReadRights }}
        >
            <Form form={form} layout="vertical" disabled={hasOnlyReadRights}>
                <Form.Item
                    label={GetText("CustomList_ListName")}
                    name="name"
                    rules={[
                        { required: true, message: GetText("Common_Required") },
                    ]}
                >
                    <Input placeholder={GetText("CustomList_ListName")} />
                </Form.Item>
                <Form.Item
                    name="allowMembersEdit"
                    valuePropName="checked"
                >
                    <Checkbox>Tillåt medlemmar att kunna redigera</Checkbox>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default EditCustomListModal;
